import React, { Component } from "react";
import "../../App.css"
import Button from "../../components/Button/Button";
import "./HeroSection.scss"


class HeroSection extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    clicked = () => {
        window.scrollTo(0, 5300);
    }

    render() {
        return (
            <div className="text-center  hero_container">
                <img src='../../images/background_image.jpg' alt='Navi AMC Limited", "Nippon Life India Asset Management Limited'></img>
                <div className="text_box">
                    <h1 className="text_box_header">We are a FinTech offering<br />
                        Full Stack Wealth Management Suite,<br />as APIs & APPs to Financial Advisors.</h1>
                    <p className="text_box_para">If you are a Robo, Bank, Family Office or IFA looking for technology solutions.</p>
                    <div className="btn_animation pt-3"><Button onClick={() => this.clicked()} customClass="al_button_1" buttonSize="btn--medium" buttonStyle="btn--outline" text="Lets Talk"></Button></div>
                </div>
            </div>
        )
    }
}

export default HeroSection